<template>
  <main id="additional-initiator-new-or-edit" class="wrapper-content w-100">
    <div>
      <b-card class="border"
        v-for="(item, index) of processForm.processAdditionalInitiators"
        :key="index"
        >
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <LmTreeSelect
              class="mt-4"
              label="Tipo de identificador"
              :options="currentInitiatorType.idType"
              v-model="item.identifier.type"
            />
            <LmTextInput
              label="Número"
              v-model="item.identifier.id"
              @input="$emit('onAdditionalInitiatorChange', index)"
            />
            <lm-button-v2 v-if="showAddOrRemoveButtons" type="primary" @click="$emit('onSearchAdditionalInitiator', index)" >
              {{ $t('search') }}
            </lm-button-v2>
            <lm-button-v2 v-if="showAddOrRemoveButtons" type="primary" class="ml-2" @click="$emit('onDeleteAdditionalInitiator', index)" >
              {{ $t('takeoff') }}
            </lm-button-v2>
          </div>
          <div class="col-md-8 col-sm-12">
            <a-descriptions :title="`Iniciador Adicional (${index+1}):`" layout="vertical">
              <template v-if="!item.isLoading">
                <a-descriptions-item label="Nombre o Razón Social">
                  {{ item.additionalInitiator.personName }}
                </a-descriptions-item>
                <a-descriptions-item label="Email" span="1">
                  {{ item.additionalInitiator.personEmail }}
                </a-descriptions-item>
              </template>
            </a-descriptions>
            <lm-button-v2 v-if="!item.isLoading" type="primary" @click="$emit('onShowAdditionalInitiatorDetails', index)" >
              {{ $t('view_more') }}
            </lm-button-v2>
          </div>
        </div>
      </b-card>
      <lm-button-v2 v-if="showAddOrRemoveButtons" class="mt-2" type="primary" @click="$emit('onAddAdditionalInitiator', index)" >
        {{ $t('add') }}
      </lm-button-v2>
    </div>
</main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'

export default {
  components: {
    LmTextInput,
    LmTreeSelect,
    LmButtonV2
  },
  props: {
    currentInitiatorType: {
      type: Object
    },
    processForm: {
      type: Object
    },
    actionsAvailables: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  validations: {
  },
  computed: {
    showAddOrRemoveButtons () {
      return (this.actionsAvailables.processCanBeEditedByMe || this.actionsAvailables.processCanBeEditedByMePermissions)
    }
  },
  methods: {
  },
  async created () {
  },
  async mounted () {
  }
}

</script>
